import { useStoreActions } from '~/store/store-context';
import { useMutationState } from '../useMutationState';
export const useSaveCustomPageText = ()=>{
    const { api } = useStoreActions();
    const { mutateAsync, isLoading } = useMutationState({
        mutationFn: (param)=>{
            let { businessId, content } = param;
            return api.customPage.saveText(businessId, content);
        }
    });
    return {
        saveText: mutateAsync,
        isLoading
    };
};
